import { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";
import { api, useSite, mediaUrl } from "@/lib/site";
import { inp, Fld, BiText, UploadBtn } from "./ui";

const CountryCard = ({ c, onSaved }) => {
  const [f, setF] = useState(c);
  const save = async () => {
    try {
      if (f.id) await api.put(`/admin/countries/${f.id}`, f); else await api.post("/admin/countries", f);
      toast.success("Uložené"); onSaved();
    } catch { toast.error("Uloženie zlyhalo"); }
  };
  const del = async () => { if (f.id && window.confirm("Zmazať krajinu?")) { await api.delete(`/admin/countries/${f.id}`); onSaved(); } };
  const setRegion = (i, name) => setF((o) => ({ ...o, regions: o.regions.map((r, k) => (k === i ? { ...r, name } : r)) }));
  return (
    <div className="bg-white border border-sand/60 p-5 space-y-4" data-testid={`country-card-${f.slug || "new"}`}>
      <div className="flex gap-4 items-start">
        {f.image ? <img src={mediaUrl(f.image)} alt="" className="w-24 h-24 object-cover" /> : <div className="w-24 h-24 bg-sand/40" />}
        <div className="flex-1 space-y-3">
          <BiText label="Krajina" value={f.name} onChange={(name) => setF((o) => ({ ...o, name, slug: o.slug || (name.en || name.sk || "").toLowerCase() }))} testid="country-name" />
          <div className="flex flex-wrap gap-3 items-end">
            <Fld label="URL slug" className="w-40"><input className={inp} value={f.slug} onChange={(e) => setF((o) => ({ ...o, slug: e.target.value }))} /></Fld>
            <UploadBtn testid="country-upload" label="Foto krajiny" onUploaded={(u) => setF((o) => ({ ...o, image: u }))} />
          </div>
        </div>
      </div>
      <Fld label="Kraje / regióny">
        <div className="space-y-2">
          {f.regions.map((r, i) => (
            <div key={r.id || i} className="flex gap-2 items-end">
              <div className="flex-1"><BiText label={`Kraj ${i + 1}`} value={r.name} onChange={(name) => setRegion(i, name)} testid={`region-${i}`} /></div>
              <button type="button" onClick={() => setF((o) => ({ ...o, regions: o.regions.filter((_, k) => k !== i) }))} className="px-2 pb-3 text-midnight/50 hover:text-red-600"><X size={16} /></button>
            </div>
          ))}
          <button type="button" data-testid="add-region-btn" onClick={() => setF((o) => ({ ...o, regions: [...o.regions, { name: { sk: "", en: "" } }] }))} className="text-xs tracking-[0.15em] uppercase text-gold flex items-center gap-1"><Plus size={14} /> Pridať kraj</button>
        </div>
      </Fld>
      <div className="flex justify-end gap-3">
        {f.id && <button onClick={del} className="text-midnight/50 hover:text-red-600" data-testid="delete-country-btn"><Trash2 size={16} /></button>}
        <button onClick={save} className="btn-gold" data-testid="save-country-btn">Uložiť</button>
      </div>
    </div>
  );
};

export const CountriesAdmin = () => {
  const { countries, reload } = useSite();
  const [adding, setAdding] = useState(false);
  useEffect(() => { reload(); }, []); // eslint-disable-line
  const done = () => { setAdding(false); reload(); };
  return (
    <div data-testid="admin-countries">
      <div className="flex justify-between items-center mb-6">
        <h2 className="font-display text-3xl text-midnight">Krajiny a kraje</h2>
        <button className="btn-gold" onClick={() => setAdding(true)} data-testid="add-country-btn"><Plus size={14} /> Nová krajina</button>
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        {adding && <CountryCard c={{ name: { sk: "", en: "" }, slug: "", image: "", regions: [] }} onSaved={done} />}
        {countries.map((c) => <CountryCard key={c.id + JSON.stringify(c).length} c={c} onSaved={done} />)}
      </div>
    </div>
  );
};
